import React from 'react'

const AnimeIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="animeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 100, 150, 1)" />
          <stop offset="100%" stopColor="rgba(150, 100, 255, 1)" />
        </linearGradient>
        <filter id="animeGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Japanese flag circle */}
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="url(#animeGradient)"
        strokeWidth="2"
        fill="rgba(255, 100, 150, 0.1)"
        filter="url(#animeGlow)"
      />
      
      {/* Inner red circle (sun) */}
      <circle
        cx="12"
        cy="12"
        r="5"
        fill="rgba(255, 50, 100, 0.8)"
      />
      
      {/* Anime sparkles */}
      <path
        d="M6 6 L7 7 L6 8 L5 7 Z"
        fill="rgba(255, 200, 100, 1)"
      />
      <path
        d="M18 6 L19 7 L18 8 L17 7 Z"
        fill="rgba(255, 200, 100, 1)"
      />
      <path
        d="M6 18 L7 19 L6 20 L5 19 Z"
        fill="rgba(255, 200, 100, 1)"
      />
      <path
        d="M18 18 L19 19 L18 20 L17 19 Z"
        fill="rgba(255, 200, 100, 1)"
      />
    </svg>
  )
}

export default AnimeIcon
